import type { Template } from "@/types";

export const PO_05_H5_V0: Template[] = [
    {
        id: "po-05-h5v0-01",
        name: "PO 01 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_01.png",
        size: [1252, 894],
        style: {},
        slots: [          
            { id: "1", x: 41, y: 242, width: 248, height: 179, rotation: 0, imageRotation: 0 },
            { id: "2", x: 41, y: 429, width: 248, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 297, y: 242, width: 247, height: 179, rotation: 0, imageRotation: 0 },
            { id: "4", x: 297, y: 429, width: 247, height: 178, rotation: 0, imageRotation: 0 },
            { id: "5", x: 642, y: 242, width: 503, height: 366, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-02",
        name: "PO 02 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_02.png",
        size: [1190, 850],
        style: {},
        slots: [      
            { id: "1", x: 0, y: 211, width: 292, height: 211, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 430, width: 292, height: 210, rotation: 0, imageRotation: 0 },
            { id: "3", x: 300, y: 211, width: 291, height: 211, rotation: 0, imageRotation: 0 },
            { id: "4", x: 300, y: 430, width: 291, height: 210, rotation: 0, imageRotation: 0 },
            { id: "5", x: 599, y: 211, width: 591, height: 429, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-03",
        name: "PO 03 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_03.png",
        size: [1190, 850],
        style: {},
        slots: [           
            { id: "1", x: 0, y: 211, width: 292, height: 211, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 430, width: 292, height: 210, rotation: 0, imageRotation: 0 },
            { id: "3", x: 299, y: 211, width: 590, height: 429, rotation: 0, imageRotation: 0 },
            { id: "4", x: 897, y: 211, width: 293, height: 211, rotation: 0, imageRotation: 0 },
            { id: "5", x: 897, y: 430, width: 293, height: 210, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-04",
        name: "PO 04 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 47, y: 181, width: 503, height: 366, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 47, y: 554, width: 163, height: 116, rotation: 0, imageRotation: 0 },
            { id: "3", x: 218, y: 554, width: 162, height: 116, rotation: 0, imageRotation: 0 },
            { id: "4", x: 388, y: 554, width: 162, height: 116, rotation: 0, imageRotation: 0 },
            { id: "5", x: 642, y: 242, width: 503, height: 366, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-05",
        name: "PO 05 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 210, width: 595, height: 431, rotation: 0, imageRotation: 0 },
            { id: "2", x: 706, y: 87, width: 372, height: 266, rotation: 0, imageRotation: 0 },
            { id: "3", x: 706, y: 361, width: 372, height: 265, rotation: 0, imageRotation: 0 },
            { id: "4", x: 706, y: 634, width: 182, height: 129, rotation: 0, imageRotation: 0 },
            { id: "5", x: 896, y: 634, width: 182, height: 129, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-06",
        name: "PO 06 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 181, y: 149, width: 248, height: 179, rotation: 0, imageRotation: 0 },
            { id: "2", x: 50, y: 336, width: 247, height: 180, rotation: 0, imageRotation: 0 },
            { id: "3", x: 305, y: 336, width: 247, height: 180, rotation: 0, imageRotation: 0 },        
            { id: "4", x: 181, y: 524, width: 248, height: 178, rotation: 0, imageRotation: 0 },
            { id: "5", x: 642, y: 242, width: 503, height: 366, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-07",
        name: "PO 07 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 138, y: 84, width: 320, height: 223, rotation: 0, imageRotation: 0 },
            { id: "2", x: 138, y: 315, width: 320, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 138, y: 545, width: 320, height: 222, rotation: 0, imageRotation: 0 },
            { id: "4", x: 661, y: 84, width: 464, height: 338, rotation: 0, imageRotation: 0 },
            { id: "5", x: 661, y: 430, width: 464, height: 337, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-08",
        name: "PO 08 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 36, y: 233, width: 509, height: 367, rotation: 0, imageRotation: 0 },
            { id: "2", x: 691, y: 86, width: 365, height: 259, rotation: 0, imageRotation: 0 },
            { id: "3", x: 691, y: 487, width: 365, height: 259, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 353, width: 179, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 878, y: 353, width: 178, height: 126, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-09",
        name: "PO 09 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_09.png",
        size: [1190, 850],
        style: {},
        slots: [        
            { id: "1", x: 67, y: 226, width: 259, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 67, y: 429, width: 259, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 334, y: 226, width: 523, height: 398, rotation: 0, imageRotation: 0 },
            { id: "4", x: 865, y: 226, width: 259, height: 195, rotation: 0, imageRotation: 0 },
            { id: "5", x: 865, y: 429, width: 259, height: 195, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-10",
        name: "PO 10 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_10.png",
        size: [1190, 850],
        style: {},
        slots: [         
            { id: "1", x: 67, y: 125, width: 206, height: 145, rotation: 0, imageRotation: 0 },
            { id: "2", x: 67, y: 278, width: 206, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 67, y: 430, width: 206, height: 144, rotation: 0, imageRotation: 0 },
            { id: "4", x: 67, y: 582, width: 206, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 280, y: 125, width: 843, height: 601, rotation: 0, imageRotation: 0 }
        ],
    }
];